import React from 'react';
import { Link } from 'react-router-dom';
import BoTStatus from './BoTStatus';
import BusinessMetrics from './BusinessMetrics';
import SkillsUpdates from './SkillsUpdates';

const Dashboard: React.FC = () => {
  return (
    <div className="dashboard">
      <h1>QuantumSphere Dashboard</h1>
      
      <div className="grid">
        <div className="grid-item">
          <h2>Board of Trustees Status</h2>
          <BoTStatus />
          <Link to="/bot">View Details</Link>
        </div>
        
        <div className="grid-item">
          <h2>Business Metrics</h2>
          <BusinessMetrics />
          <Link to="/businesses">View Details</Link>
        </div>
        
        <div className="grid-item">
          <h2>Skills Library Updates</h2>
          <SkillsUpdates />
          <Link to="/skills">View Details</Link>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
